// extracted by mini-css-extract-plugin
export default {"video":"Video_video__6LXuA","description":"Video_description__+kW6i"};